import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TextValue = _resolveComponent("TextValue");
  return _openBlock(), _createBlock(_component_TextValue, {
    value: $options.highlightedValue,
    size: $props.size,
    color: $props.color,
    styles: $props.styles,
    main: $props.main
  }, null, 8, ["value", "size", "color", "styles", "main"]);
}